import './QuoteForm.css';
import React from 'react';
import { useState } from 'react';
import emailjs from '@emailjs/browser';

function QuoteForm() {


  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");





  const handleChange = (e) => {
    const {name, value} = e.target;
  };

  const [focused, setFocused] = useState(false);
  const handleFocus = (e) => {
    setFocused(true);
  };


  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = {};
    // Your EmailJs SeviceId templete ID and public key needs to be changed once they have account
    const serviceId = 'service_3bjhbs9';
    const templateId = 'template_9fsztfa';
    const publicKey = 'klD8MNbPbzl71AjXZ';
    // Create obj that conatins dynamic temple params
    const templeParamas = {
      name: name,
      email: email,
      number: number,
      message: message,
    };

    //Send the email using EmailJs
    emailjs.send(serviceId, templateId, templeParamas, publicKey)
      .then((response) => {
        console.log('Email sent Successfully', response);
        setName('');
        setNumber('');
        setEmail('');
        setMessage('');
      })
      .catch((error) =>{
        console.error('error sending email', error)
      });
    alert("Submitted " + name);
  }

  return (
    <div class="quoteForm">
      <div>
        Let's Get Started Today!
      </div>
      <div>
        get a free quote
      </div>
      <form onSubmit={handleSubmit}>
        <input class="name"
          type="text"
          value={name}
          placeholder="Full Name"
          required
          pattern="^[a-zA-Z\s]{2,16}$"
          onChange={(e) => setName(e.target.value)}/>
        <div class="middle">
            <input class="number"
              type="phoneNumber"
              value={number}
              placeholder="Phone Number"
              required
              onChange={(e) => setNumber(e.target.value)}/>
            <input class="number"
              type="email"
              value={email}
              placeholder="Email Address"
              required
              onChange={(e) => setEmail(e.target.value)}/>
        </div>
        <textarea
          type="textarea"
          value={message}
          placeholder="Message"
          required
          onChange={(e) => setMessage(e.target.value)}/>
        <input type="submit" value="Request An Estimate"/>
      </form>
    </div>
  )
}

export default QuoteForm;
